import { ICreateEngagementResponse, ICreateOneLinkSendResponse } from '../../../types/bucket';
import { TSendsV2Response } from '../../../types/sendsV2';
import { IApiError } from '../../../types/shell';

export const CS_SUBMIT_REQUESTED = 'CS_SUBMIT_REQUESTED';
export const CS_SUBMIT_SUCCESS = 'CS_SUBMIT_SUCCESS';
export const CS_SUBMIT_FAILURE = 'CS_SUBMIT_FAILURE';
export const CS_RESET_SUBMIT_ERROR = 'CS_RESET_SUBMIT_ERROR';
export const CS_CRM_OPPORTUNITY_PROMPTED = 'CS_CRM_OPPORTUNITY_PROMPTED';
export const CS_CRM_OPPORTUNITY_CHOSEN = 'CS_CRM_OPPORTUNITY_CHOSEN';
export const CS_CRM_OPPORTUNITY_CANCELLED = 'CS_CRM_OPPORTUNITY_CANCELLED';

export const csSubmitRequested = () => ({
  type: CS_SUBMIT_REQUESTED,
});

export const csSubmitSuccess = (
  payload: ICreateEngagementResponse | ICreateOneLinkSendResponse | TSendsV2Response,
) => ({
  type: CS_SUBMIT_SUCCESS,
  payload,
});

export const csSubmitFailure = (payload: unknown | IApiError) => ({
  type: CS_SUBMIT_FAILURE,
  payload,
});

export const csResetSubmitError = () => ({
  type: CS_RESET_SUBMIT_ERROR,
});

export const csCrmOpportunityPrompted = () => ({
  type: CS_CRM_OPPORTUNITY_PROMPTED,
});

export const csCrmOpportunityChosen = (payload: { opportunityId: string }) => ({
  type: CS_CRM_OPPORTUNITY_CHOSEN,
  payload,
});

export const csCrmOpportunityCancelled = () => ({
  type: CS_CRM_OPPORTUNITY_CANCELLED,
});
